/**
 * Category display helpers.
 *
 * The backend already converts Plaid's raw category enums (FOOD_AND_DRINK,
 * TRANSFER_OUT, ...) to friendly labels in every API response. formatCategory
 * is a defensive fallback: if a raw enum ever slips through (stale cache,
 * old data), it is humanized client-side so the user never sees SCREAMING_SNAKE.
 */

const ACRONYMS = new Set(['TV', 'ATM', 'P2P', 'RV', 'BNPL', 'EWA']);

/** True when the value still looks like a raw Plaid enum, e.g. "FOOD_AND_DRINK". */
const isRawEnum = (value: string): boolean => /^[A-Z0-9_]+$/.test(value) && value.includes('_');

export const formatCategory = (value?: string | null): string => {
  if (!value) return 'Other';
  if (!isRawEnum(value) && !/^[A-Z0-9]+$/.test(value)) return value; // already friendly
  return value
    .split('_')
    .map(word => {
      if (word === 'AND') return '&';
      if (ACRONYMS.has(word)) return word;
      return word.charAt(0) + word.slice(1).toLowerCase();
    })
    .join(' ');
};
